"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SSE = void 0;
var _server = require("./server");
var _SSE = require("../../constants/SSE");
var _notifications = require("../notifications/notifications");
var _pollux_dms = require("../../pollux_dms");
var _build_config = require("../config/build_config");
/**
 * @Author: Ildomar Gomes
 * @Date:   2022-08-06 14:49:10
 */

/*
 * Description: This manager allows your component to
 * receive Server Side Events.
 */

const SSE = exports.SSE = {
  _eventSource: null,
  _eventHandlers: [],
  init: function () {
    const config = (0, _build_config.getBuildConfiguration)();
    if (config.enableSSE) {
      this._connect();
    }
  },
  _connect: function () {
    const url = (0, _server.getURL)("/sse");
    if (this._eventSource != null) {
      this._eventSource.close();
    }
    this._eventSource = new EventSource(url);
    this._eventSource.addEventListener("open", e => {
      // SSE is connected

      const handleSSENotification = (topic, data) => {
        let id = null;
        if (data.id) id = data.id;else id = (0, _pollux_dms.generate_random_id)();
        _notifications.Notifications.add(id, data);
      };
      const handleSSEToast = (topic, data) => {
        _notifications.Notifications.toast(data);
      };
      this.unregister(_SSE.SSE_Events.Notification);
      this.unregister(_SSE.SSE_Events.Toast);
      this.register(_SSE.SSE_Events.Notification, handleSSENotification);
      this.register(_SSE.SSE_Events.Toast, handleSSEToast);
    });
    this._eventSource.addEventListener("error", e => {
      // When SSE is not responding
    });
    this._eventSource.addEventListener("message", e => {
      const data = JSON.parse(e.data);
      this.handle(data.topic, data.data);
    });
  },
  register: function (topic, handler) {
    let key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    this._eventHandlers.push({
      topic: topic,
      handler: handler,
      key: key
    });
  },
  unregister: function (topic) {
    let key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    for (let i = 0; i < this._eventHandlers.length; i++) {
      if (this._eventHandlers[i].topic == topic) {
        if (this._eventHandlers[i].key != key) {
          continue;
        }
        this._eventHandlers.splice(i, 1);
        i--;
      }
    }
  },
  handle: function (topic, data) {
    for (let i = 0; i < this._eventHandlers.length; i++) {
      if (this._eventHandlers[i].topic == topic) {
        this._eventHandlers[i].handler(topic, data);
      }
    }
  }
};